import * as THREE from 'three';
import * as CANNON from 'cannon-es';

class CameraEngineChaseCopter {
	// камера, автоматически преследующая машину игрока, держится сверху-сзади, смотрит на машину 
	
	camera: THREE.PerspectiveCamera;
	
	mode = 0;  // 0 - стоим на месте, 1 - догоняем

//	dx = 0;
//	dz = 0;	
	
	constructor(scene: THREE.Scene, position: CANNON.Vec3, quaternion: CANNON.Quaternion) {
		//


//		this.camera = new THREE.PerspectiveCamera( 45, window.innerWidth / window.innerHeight, 0.01, 1000 );
		this.camera = new THREE.PerspectiveCamera( 35, window.innerWidth / window.innerHeight, 0.01, 1000 );
//		this.camera = new THREE.PerspectiveCamera( 35, window.innerWidth / window.innerHeight, 0.01, 1500 );
		
//		this.camera.position.z = 10;
		this.camera.position.set(30, -10, 10);
		this.camera.lookAt(0, 0, 0);
		
		scene.add(this.camera);
		
		
	}
	/////////////////////////////////////////////////////////
	animate(position: CANNON.Vec3, quaternion: CANNON.Quaternion) {
		
		// замеряем расстояние от камеры до объекта
		const distance = this.camera.position.distanceTo(position);
			
		console.log("position: " + position.x + ", " + position.y + ", " + position.z);
		console.log("camera.position: " + this.camera.position.x + ", " + this.camera.position.y + ", " + this.camera.position.z);
		console.log("distance = " + distance);

//		this.dx = (position.x - this.camera.position.x) / distance * 360 / 3.6 / 60; 
//		this.dz = (position.z - this.camera.position.z) / distance * 360 / 3.6 / 60; 

		this.camera.position.y = position.y + 1;
		
		/*
		if (this.mode == 0) {  // камера стоит на месте
		
//			if (distance > 100) {
			if (distance > 3) {
				// включаем режим преследования
				this.mode = 1;
			}
			
			// смотрим на машину
			this.camera.lookAt(new THREE.Vector3(position.x, position.y, position.z));
			
		} else {  // камера гонится за машиной
		*/
		
//			if (distance < 50) {
			//if (distance < 15) {
			//	this.mode = 0;
			//} else {
				
//				this.camera.position.x += this.dx;
//				this.camera.position.z += this.dz;
				
				//this.camera.position.x = (this.camera.position.x + position.x) / 2; 
				//this.camera.position.z = (this.camera.position.z + position.z) / 2; 
				
			// удерживаем камеру на расстоянии
			const euler:CANNON.Vec3 = new CANNON.Vec3();
			quaternion.toEuler(euler);
				
			euler.normalize();
				
			const distance1 = 7;
				/*
				
				this.camera.position.x = position.x + distance1 * Math.sin(euler.y);
				this.camera.position.z = position.z + distance1 * Math.cos(euler.y);
				
				this.camera.position.y = position.y - 2 + 2 * Math.cos(euler.z);
				*/
//const q = new THREE.Quaternion().setFromEuler( e );
//const v = new THREE.Vector3( position.x, position.y, position.z).applyQuaternion(quaternion);
//const v = position.applyQuaternion(quaternion);

//const offset = 1; // world units

			const v = new THREE.Vector3( 0, 0, 1 ).applyQuaternion( quaternion );

//const v = new THREE.Vector3( euler.x, euler.y, euler.z)

			const camPosition: THREE.Vector3 = new THREE.Vector3( position.x, position.y, position.z).add( v.multiplyScalar( distance1 ) );				
				
			this.camera.position.x = camPosition.x; 
//			this.camera.position.y = camPosition.y + 0.25; 
///			this.camera.position.y = camPosition.y + 0.5; 
			this.camera.position.y = camPosition.y + 1; 
			this.camera.position.z = camPosition.z; 
				
				
			//}
			
			
			// смотрим на машину и чуть выше
			this.camera.lookAt(new THREE.Vector3(position.x, position.y + 1.5, position.z));

			
		//}

		
		//console.log("dx = " + dx);
		//console.log("dz = " + dz);
		
		
		
		
		/*	
		const x = position.x;
		const y = position.y;
		const z = position.z;
			
			
		this.camera.position.x = x;// + 100;
		this.camera.position.y = y + 20;
		this.camera.position.z = z;

		const q = new THREE.Quaternion()
			.set(
			quaternion.x,
			quaternion.y,
			quaternion.z,
			quaternion.w
			).normalize();
			
			this.camera.setRotationFromQuaternion(q);
			
//			const euler = new THREE.Euler();
//			euler.x = this.vehiclePhys.chassisBody.rotation.x;
//			euler.y = this.vehiclePhys.chassisBody.rotation.y;
//			euler.order = "XYZ";
//			const q = new THREE.Quaternion().setFromEuler(euler);
			
			this.camera.rotateY(Math.PI / 2);  // чтобы смотрела вдоль машины, а не поперёк
			///this.camera.rotateX(-Math.PI / 4); // чтобы смотрела немного вниз
//			this.camera.rotateX(Math.PI);

//			this.camera.updateProjectionMatrix();
			
			console.log("camera.position: " + x + ", " + y + ", " + z);
		
		*/
	}
	/////////////////////////////////////////////////////////
	getCamera() {
		return this.camera;
	}
	/////////////////////////////////////////////////////////
	
}
export default CameraEngineChaseCopter;